import { US_MAP_BOUNDING_BOX } from "@/constants"

/**
 * Shared default map bounds for SRP when no location is selected.
 * Used by middleware (redirect), paths.srpHomesUS(), and resolveMapViewport.
 *
 * Reads NEXT_PUBLIC_DEFAULT_MAP_TL and NEXT_PUBLIC_DEFAULT_MAP_BR from env.
 * Format: "longitude:latitude" (e.g. "-94.09585:44.72360")
 * Falls back to full US bounding box if not set or invalid.
 */

function isValidTlBr(value: string): boolean {
  const parts = value.split(":")
  if (parts.length !== 2) return false
  const a = Number(parts[0])
  const b = Number(parts[1])
  return Number.isFinite(a) && Number.isFinite(b)
}

export function getDefaultMapBounds(): { tl: string; br: string } {
  const rawTl = process.env.NEXT_PUBLIC_DEFAULT_MAP_TL
  const rawBr = process.env.NEXT_PUBLIC_DEFAULT_MAP_BR
  // Decode URL-encoded colon (%3A) — .env should use literal : but accept %3A if pasted from URL
  const tl = (rawTl ?? US_MAP_BOUNDING_BOX.topLeft).trim().replace(/%3A/gi, ":")
  const br = (rawBr ?? US_MAP_BOUNDING_BOX.bottomRight).trim().replace(/%3A/gi, ":")
  if (isValidTlBr(tl) && isValidTlBr(br)) return { tl, br }
  return { tl: US_MAP_BOUNDING_BOX.topLeft, br: US_MAP_BOUNDING_BOX.bottomRight }
}
